import React, { Component } from "react";

export default class About extends Component {
  render() {
    return (
      <main className="about">
        <section className="about_intro">
          <h1>
            " Keep it simple <br />
            <span>and Functional "</span>
          </h1>
        </section>
        <section className="social_proofSection">
          <div className="social_proofContent">
            <div>
              <h1>Himanshu Ratnani</h1>
              <p>
                Hi, I am Himanshu Ratnani, a Full Stack Developer who likes to convent an idea into a reality.
                I have 2+ years of experience working on various technologies in the field of both Web and App development.
                While I enjoy all aspects of my work, I think my favorite stage of developing a project is planning and design. As we go through the process,
                the ideas start to flow and that's always the fun part.
              </p>
              <a
                href="/resume.pdf"
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
                download
              >
                Download Resume
              </a>
            </div>
            <div className="social_proof">
              <div>
                <img src="./images/PortfolioCover.png" alt="" />
              </div>
            </div>
          </div>
          <div className="about_Skills">
            <h2>Skills</h2>
            <ul>
              <li>
                <p>Data Structures</p>
              </li>
              <li>
                <p>Html</p>
              </li>
              <li>
                <p>Css</p>
              </li>
              <li>
                <p>Javascript</p>
              </li>
              <li>
                <p>React.js</p>
              </li>
              <li>
                <p>React-Native</p>
              </li>
              <li>
                <p>React + Redux</p>
              </li>
              <li>
                <p>Firebase</p>
              </li>
              <li>
                <p>Node.js</p>
              </li>
              <li>
                <p>.NetCore</p>
              </li>
              <li>
                <p>C#</p>
              </li>
              <li>
                <p>MSSQL Server</p>
              </li>
              <li>
                <p>Git</p>
              </li>
            </ul>
          </div>
        </section>
      </main>
    );
  }
}
